export enum FileRecordAssociation {
    Associated = 1,
    NonAssociated = 2
}
